import React from "react";
import { useNavigate } from "react-router-dom";
// import img from '../marketplaceassets/buildimg.png';
import "./Build.css";

export default function Build() {
    const navigation = useNavigate();

  return (
    <div id="marketplace-build" className="marketmainclass">
      <div className="left">
        <h2 className="heading">
         Kickstart Your NFT Marketplace with Expert Web3 Guidance
        </h2>
        <p className="subheading">
          Power your NFT marketplace with Web3 experts
        </p>
        <button onClick={() => navigation("/contact_us")}>Schedule free Consultation</button>
      </div>
      {/* <div className="right">
            <img src={img} alt="error" />
        </div> */}
    </div>
  );
}
